<template>
  <div class="custom-color-input floating-label">
    <label class="product-section-title">
      {{ custom.name }}
      <template v-if="additionalCost">
        (+ {{ formatPrice(additionalCost) }})
      </template>
      <span v-if="custom.required" class="required required-span">*</span>
    </label>
    <div :class="['input-box input-colorpicker', { error: hasErrors }]">
      <ul class="gocase-colorpicker">
        <li
          v-for="color in options"
          :key="color"
          :class="{ active: inputValue === color }"
          :data-color="color"
          @click="selectOption(color)"
        >
          <span :style="`background-color: ${colorWithHash(color)};`"></span>
        </li>
      </ul>
      <input
        :id="inputId"
        v-model="inputValue"
        type="hidden"
        :name="inputName"
        class="color-value customization-field"
        data-code="color"
      />
    </div>
    <div v-if="hasErrors" class="form__field-error">
      {{ errors.join(' ') }}
    </div>
  </div>
</template>

<script>
import BaseSelect from '~/components/product/form/BaseSelect'
import priceable from '~/mixins/priceable'
export default {
  name: 'CustomColorInput',
  extends: BaseSelect,
  mixins: [priceable],
  props: {
    /** Spree color customization */
    custom: {
      type: Object,
      required: true,
    },
    /** Select first option by default */
    autoSelect: {
      type: Boolean,
      default: true,
    },
    customInputId: {
      type: String,
      default: null,
    },
    customInputName: {
      type: String,
      default: null,
    },
  },
  computed: {
    additionalCost() {
      return this.parseNumber(this.custom.additional_cost)
    },
    inputName() {
      if (this.customInputName) {
        return `${this.customInputName}[${this.custom.id}]`
      } else {
        return `customizations[${this.custom.id}]`
      }
    },
    inputId() {
      if (this.customInputId) {
        return `${this.customInputId}_${this.custom.id}`
      } else {
        return `customization_${this.custom.id}`
      }
    },
  },
  methods: {
    colorWithHash(color) {
      if (color.startsWith('#')) return color

      return '#' + color
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/gocase-colorpicker.scss';
</style>
